import {
    GET_TARIFF_REQUEST_SUCCESS,
    GET_TARIFFS_REQUEST_SUCCESS, UPDATE_TARIFFS_REQUEST_SUCCESS
} from "./actionTypes"

const INIT_STATE = {
    tariffs : [],
    tariff : {}
}

const reducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_TARIFFS_REQUEST_SUCCESS:
            return {
                ...state,
                tariffs: action.callBack.tariffs,
            }

        case GET_TARIFF_REQUEST_SUCCESS:
            return {
                ...state,
                tariff: action.callBack.tariff,
            }
        case UPDATE_TARIFFS_REQUEST_SUCCESS:
            state.tariffs[action.payload.key] = action.payload.product
            return {
                ...state,
            }


        default:
            return state
    }
}

export default reducer
